import { useEffect, useState } from "react";
import { throttle } from "lodash";

interface UseVideoProgressProps {
  videoRef: React.RefObject<HTMLMediaElement>;
}

export const useVideoProgress = ({ videoRef }: UseVideoProgressProps) => {
  const [currentTime, setCurrentTime] = useState(0);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleTimeUpdate = throttle(
      () => setCurrentTime(video.currentTime),
      500,
    );

    video.addEventListener("timeupdate", handleTimeUpdate);

    return () => {
      video.removeEventListener("timeupdate", handleTimeUpdate);
      handleTimeUpdate.cancel();
    };
  }, [videoRef]);

  return { currentTime };
};
